import {SalesRepReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import useGetSalesRepReport from '../hooks/useGetSalesRepReport'
import SalesRepReportTable from '../sections/table/SalesRepReportTable'
import {SalesRepReportHeader} from '../sections/header/SalesRepReportsHeader'
import {Pagination} from '../../../utils/pagination'
import useGetSalesRepTypeDropdown from '../hooks/useGetSalesRepTypeDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'

function SalesRepReport() {
  const {
    reportData: salesRepData,
    pagination,
    isLoading: isSalesRepLoading,
    filters,
    onSearch: onSalesRepSearch,
    onSortingChange: onSalesRepSortingChange,
    onDateChange,
    onPageChange,
    onChangeSalesRepTypeFilter,
  } = useGetSalesRepReport()

  const {
    entityPerformanceChartData,
    isLoading:isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('sales_rep')

  const {salesRepTypes, isLoading: isSalesRepTypeDropdownLoading} = useGetSalesRepTypeDropdown()

  const contextValue = {
    salesRepData,
    isSalesRepLoading,
    filters,
    onSalesRepSearch,
    onSalesRepSortingChange,
    onDateChange,
    onChangeSalesRepTypeFilter,

    salesRepTypes,
    isSalesRepTypeDropdownLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  }

  return (
    <KTCard>
      <SalesRepReportContext.Provider value={contextValue}>
        <SalesRepReportHeader />
        <SalesRepReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </SalesRepReportContext.Provider>
    </KTCard>
  )
}

export default SalesRepReport
